import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { isMobile } from '@libraries/ui-state';
import { select, Store } from '@ngrx/store';
import { isLoggedIn, isLoginLoading, logout, validatePin } from '../+state';
import { CompanyPin } from '../models';

@Component({
  selector: 'header-wrapper',
  templateUrl: './header-wrapper.component.html',
  styleUrls: ['./header-wrapper.component.scss'],
  standalone: false,
})
export class HeaderWrapperComponent implements OnInit {
  public isLoggedIn$ = this.store.pipe(select(isLoggedIn));
  public isLoginLoading$ = this.store.pipe(select(isLoginLoading));
  public isMobile$ = this.store.pipe(select(isMobile));

  @ViewChildren(MatMenuTrigger) private menuTriggers: QueryList<MatMenuTrigger>;

  constructor(private store: Store) {}

  ngOnInit() {}

  signIn(formData: CompanyPin) {
    this.store.dispatch(
      validatePin({
        payload: formData,
        closeMenu: () => this.menuTriggers.first.closeMenu,
        fromMenu: true,
      })
    );
  }

  logOut() {
    this.store.dispatch(logout());
  }
}
